import React from "react";

function Header(props) {
    return (
        <div style={props.Style} id="header">
            <h1>{props.title}</h1>
            <p>{props.text}</p>
        </div>
    );
}
Header.defaultProps = {
    title : "your title here",
    text : "your small introduction text will be here"
}

export default Header;
